import { SET_REPORTS_FILTER } from './types';

export const setReportsFilter = filter => ({
  type: SET_REPORTS_FILTER,
  filter,
});
